import fileDownload from 'js-file-download'
import axios from 'axios'
import { getPimBaseUrl } from './config'
import { hashCode } from './utils'

import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { $getIJoistManufacturer } from './apis'
import { globalAlertActions } from './slices/alert.slice'

export const fetchData = async (url) => {
  return await axios.get(url)
}

export const postRequest = async (url, payload, options) => {
  return await axios.post(url, payload, options)
}

export const options = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  },
  timeout: 10000,
}

export const optionsMultipartForm = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  },
  timeout: 120000, // Increase timeout to handle large files upload
}

//using axios
export async function postAPI(url, payload) {
  const options = {
    method: 'POST',
    url: url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: payload,
  }

  return await axios(options)
}

export const doDownload = (myState, fileName) => {
  // fileDownload(JSON.stringify(myState, null, 2), fileName + '.json')
  // gaEventWrapper(gaEventName, 'Download_Action', 'Download')

  const myStr = JSON.stringify(myState, null, 0)
  const myHash = hashCode(myStr)
  // console.log('download myHash=', myHash)
  // console.log('download myStr=', myStr)

  const myObj = Object.assign({}, { hash: myHash, source: myState })

  fileDownload(JSON.stringify(myObj, null, 2), fileName + '.json')
}

export const sendNotice = (dispatch, notice) => {
  const defaultNotice = { noticeLevel: '', noticeIconUrl: '', noticeHeader: '', noticeBody: '' }
  const noticeObj = Object.assign({}, defaultNotice, notice)

  dispatch({ type: 'FIELD_UPDATE_STATUS', payload: noticeObj /* { ...noticeObj } */ })
}

export const clearMsg = (dispatch) => {
  dispatch({ type: 'CLEAR_GLOBAL_MSG' })
}

export const clearNotice = (dispatch) => {
  dispatch({ type: 'CLEAR_NOTICE' })
}

export const handleProductLinkClick = (model, categories) => {
  const baseUrl = getPimBaseUrl(window.location.hostname)
  const searchUrl =
    '/search?v=' +
    model +
    '%3Arelevance' +
    (categories ? '%3A' + categories + '&format=json' : '&format=json')
  const url = baseUrl + searchUrl
  // console.log('--search URL -- ', url)
  let windowReference

  const launchPDPUrl = async () => {
    try {
      const result = await fetchData(url)
      if (
        result &&
        result.data &&
        result.data.results &&
        result.data.results.product &&
        result.data.results.product.searchPageData &&
        result.data.results.product.searchPageData.results[0]
      ) {
        const myList = result.data.results.product.searchPageData.results

        // myList.forEach((entry, index) => console.log('index=', index, ' url=', entry.url));

        const PDPUrl = result.data.results.product.searchPageData.results[0].url
        // console.log('--result -- holdownModel ', model)
        // console.log('--result -- PDPurl ', PDPUrl)
        windowReference = window.open(baseUrl + PDPUrl)
        if (window.focus && windowReference) {
          windowReference.focus()
        }
      }
    } catch (error) {
      console.log('--search API error--', error)
    }
  }

  launchPDPUrl()
}

export const resetAction = () => {
  window.location.reload()
}

export const downloadAction = createAction('global/download')
export const printAction = createAction('global/print')
export const uploadAction = createAction('global/upload')
export const cancelUploadAction = createAction('global/cancelUpload')
export const cancelPrintAction = createAction('global/cancelPrint')
export const feedbackAction = createAction('global/feedback')
export const skipGAEventAction = createAction('global/skipGAEvent')

export const getIJoistManufacturer = createAsyncThunk(
  'request/getIJoistManufacturer',
  async ({ member, body }, { rejectWithValue }) => {
    try {
      const response = await $getIJoistManufacturer(member, body)

      return response
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

let sendMsgTimeout

export const sendMsgAction = (payload) => (dispatch) => {
  dispatch(globalAlertActions.createAlertMessage(payload))
  clearTimeout(sendMsgTimeout)
  sendMsgTimeout = setTimeout(() => {
    dispatch(globalAlertActions.clearAlertMessage())
  }, 5000)
}

export function createActionsFromState(inputState) {
  return Object.keys(inputState).map((inputName) => {
    const action = createAction(`${inputName}/updateCalculation`)
    return action(inputState[inputName])
  })
}
